import { useEffect } from "react";
import { useShallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";
import { BmAddOn } from "mobily-ui-library";
import { useAddMeshExtender } from "../hooks/useAddMeshExtender";
import { useValidateShoppingCart } from "../hooks/useValidateShoppingCart";
import { useCheckoutStore } from "../stores/checkoutStore";
import { useGlobalStore } from "../stores/globalStore";
import { useGetStructure } from "../hooks/useGetStructure";
import { useQualifyProductOffers } from "../hooks/useQualifyProductOffers";
import { useCaptureShoppingCart } from "../hooks/useCaptureShoppingCart";
import Wifi_Mesh_Extender from "../assets/Wifi_Mesh_Extenders.png";

export const MeshExtender = () => {
    const { t } = useTranslation();
    const addMeshExtender = useAddMeshExtender();
    const validateShoppingCart = useValidateShoppingCart();
    const { fetchStructure} = useGetStructure();
    const fetchQualifyProductOffers = useQualifyProductOffers();
    const captureShoppingCart = useCaptureShoppingCart();

    const { shoppingCart, setShoppingCart, qualifyProductOffersResponse, setQualifyProductOffersResponse, setIsMeshExtenderOpted } = useGlobalStore(useShallow((state) => ({
        shoppingCart: state.shoppingCart,
        setShoppingCart: state.setShoppingCart,
        setQualifyProductOffersResponse: state.setQualifyProductOffersResponse,
        qualifyProductOffersResponse: state.qualifyProductOffersResponse,
        setIsMeshExtenderOpted: state.setIsMeshExtenderOpted,
    })))
    
    const { goToNextStep, updateStructure, currentSection, currentStep, capturedData, setCapturedData } = useCheckoutStore(useShallow((state) => ({
        goToNextStep: state.goToNextStep,
        updateStructure: state.updateStructure,
        currentSection: state.currentSection,
        currentStep: state.currentStep,
        capturedData: state.capturedData,
        setCapturedData: state.setCapturedData,
    })));

    const handleMeshExtender = async (shouldAddMeshExtender: boolean) => {
        const existingSection = capturedData.find((s) => s.sectionId === currentSection?.sectionId);
        const newStep = {
            sequence: currentStep?.sequence,
            stepId: currentStep?.stepId,
            offerContainerId: currentStep?.offerContainerId,
            options: [
                {
                    name: "Wi-Fi Extender Opted",
                    value: shouldAddMeshExtender ? "Yes" : "No"
                }
            ]    
        }
        const addOnSection = {
            sectionId: currentSection?.sectionId,
            steps: [
                ...(existingSection?.steps ?? []).filter((s: any) => s.stepId !== currentStep?.stepId),
                newStep,
            ]
        }
        const updatedCapturedData = [
            ...capturedData.filter((s) => s.sectionId !== addOnSection.sectionId),
            addOnSection, 
        ];

        setCapturedData(addOnSection);
        setIsMeshExtenderOpted(shouldAddMeshExtender);

        await captureShoppingCart({
            shoppingCart,
            capturedSections: updatedCapturedData
        });

        if (shouldAddMeshExtender) {
            const meshQualificationItems = qualifyProductOffersResponse
                ?.productOfferingQualificationItemContainer?.[0]
                ?.productOfferingQualificationItem;
            const meshQualificationItem = meshQualificationItems?.filter((item: any) => item.productOffering?.name.includes("Free Wifi Mesh Extender"))?.[0];
            const productId: string = meshQualificationItem?.productOffering?.id ?? "";
            const productName: string = meshQualificationItem?.productOffering?.name ?? "";
            const quantity: number = 2;
            if (productId) {
                const cartResponse = await addMeshExtender({ productId, productName, quantity })
                if (cartResponse.status === 201) {
                    const validatedCart = await validateShoppingCart(shoppingCart?.id);
                    setShoppingCart(validatedCart.data?.shoppingCart);
                    const structureResponse = await fetchStructure(validatedCart.data?.shoppingCart);
                    updateStructure(structureResponse.data);
                }
            }
        }
        const structureResponse = await fetchStructure(shoppingCart);
        updateStructure(structureResponse.data);
        goToNextStep();
    }

    useEffect(() => {
        fetchQualifyProductOffers().then(response => {
            setQualifyProductOffersResponse(response.data);
        });
    }, [])
    
    return (
        <BmAddOn
            headerTitle={t("meshExtendTitle")}
            headerSubtitle={t("meshExtendSubTitle")}
            title={t("meshExtendImgTitle")}
            subtitle={t("meshExtendImgTag-free")}
            description={t("meshExtendTerminationText")}
            imageUrl={Wifi_Mesh_Extender}
            skipText={t("skipBtn")}
            addText={t("addToOrderBtn")}
            onSkip={() => handleMeshExtender(false)}
            onAdd={() => handleMeshExtender(true)}
            
        />
    );
}